import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

import ErrorFullPage from './Page'
import ErrorLocal from './Local'
import translations from './translations'
import AccessForbidden from 'components/Error/AccessForbidden'
import { LOGIN } from 'routes'
import { useEffect } from 'react'

export const TYPES = {
  ERROR: 'An error occured',
  NOT_FOUND: '404: page not found',
  RESOURCE_NOT_FOUND: '404: resource not found',
  USER_DISABLED: 'You do not have the right to perform this action',
  NOT_LOGGED_IN: 'you must be logged in',
}

function getMessagesForError(type) {
  let title, message
  switch (type) {
    case TYPES.RESOURCE_NOT_FOUND: {
      title = translations.resourceNotFoundTitle
      message = translations.resourceNotFoundMessage
      break
    }
    case TYPES.NOT_FOUND: {
      title = translations.notFoundTitle
      message = translations.notFoundMessage
      break
    }
    case TYPES.USER_DISABLED: {
      title = translations.disabledUserTitle
      message = translations.disabledUserMessage
      break
    }
    default:
    case TYPES.ERROR: {
      title = translations.errorTitle
      message = translations.errorMessage
    }
  }
  return { title, message }
}

function Error({ type = TYPES.ERROR, retry, goToHome }) {
  const { title, message } = getMessagesForError(type)

  useEffect(() => {
    if (type === TYPES.NOT_LOGGED_IN) {
      window.location.href = LOGIN()
    }
  }, [type])

  if (type === TYPES.USER_DISABLED) {
    return <AccessForbidden title={title} message={message} switchOrganization={true} />
  }
  return <ErrorLocal title={title} message={message} retry={retry} goToHome={goToHome} />
}

function ErrorPage({ type = TYPES.ERROR }) {
  const { title, message } = getMessagesForError(type)

  useEffect(() => {
    if (type === TYPES.NOT_LOGGED_IN) {
      window.location.href = LOGIN()
    }
  }, [type])

  if (type === TYPES.USER_DISABLED) {
    return <AccessForbidden title={title} message={message} switchOrganization={true} />
  }
  return <ErrorFullPage title={title} message={message} />
}

function ErrorRoot({ type = TYPES.ERROR }) {
  const { title, message } = getMessagesForError(type)
  return <ErrorFullPage title={title} message={message} />
}

export function ErrorBoundary({ children }) {
  return <ReactErrorBoundary fallback={<Error />}>{children}</ReactErrorBoundary>
}

Error.Page = ErrorPage
Error.Root = ErrorRoot
export default Error
